import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  FaBriefcase,
  FaLocationArrow,
  FaRegStar,
  FaStar,
} from "react-icons/fa";
import TalentImg from "../../assets/images/talent-img.png";
import { CLIENT } from "../../Router/paths";
import { axiosInstance } from "../../config/https";
import { useLoader } from "../../context/LoaderContext";

export default function SavedTalents() {
  const { startLoader, stopLoader } = useLoader();
  const [hires, setHires] = useState([]);

  useEffect(() => {
    getHires();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getHires = () => {
    startLoader();
    axiosInstance
      .get("/api/client/api/recent_freelancers/")
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          setHires(Data);
        } else {
          toast.warning(Data.msg);
        }
      })
      .catch(() => {
        stopLoader();
      });
  };

  const handleReview = (sellerId, value) => {
    startLoader();
    axiosInstance
      .post(`/api/seller/${sellerId}/rating/`, {
        value,
      })
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          getHires();
          toast.success("Rate Successfully");
        } else {
          toast.warning(Data.msg);
        }
      })
      .catch(() => {
        stopLoader();
      });
  };
  return (
    <section className="talent-sec pc-p-3">
      <div className="conainter-fluid px-5">
        <div className="row">
          <div className="col-lg-3 col-md-3 col-12">
            <div className="talent-list">
              <ul>
                <li className="mb-2">
                  <Link to={CLIENT.talents}>
                    <FaBriefcase /> Your hires
                  </Link>
                </li>
                {/* <li>
                  <Link to={CLIENT.discover}>
                    <FaLocationArrow /> Discover
                  </Link>
                </li> */}
                {/* <li>
                  {" "}
                  <a href="javascript:void(0)">
                    {" "}
                    <FaBuilding /> Company
                    hires{" "}
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a href="javascript:void(0)">
                    {" "}
                    <FaUsers /> bnr talent
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a href="javascript:void(0)">
                    {" "}
                    <BsPencilSquare />
                    Recently reviewed{" "}
                  </a>{" "}
                </li> */}
              </ul>
            </div>
            {/* <div className="talent-list mt-5">
              <h5>
                Your List <FaPlusCircle />
              </h5>
              <ul>
                <li>
                  {" "}
                  <a href="javascript:void(0)">
                    {" "}
                    <FaHeart /> Saved
                    talent{" "}
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a href="javascript:void(0)">
                    {" "}
                    <BsPencilSquare />
                    Saved Projects{" "}
                  </a>{" "}
                </li>
              </ul>
            </div> */}
          </div>
          <div className="col-lg-9 col-md-9 col-12">
            <div className="primary-heading color-dark">
              <h3 className="color-secondary">Your Hires</h3>
              <p>look up people you have hired</p>
            </div>
            <div className="row">
              {hires.map((e, i) => (
                <div className="col-lg-4 col-md-4 col-12 mb-1" key={i}>
                  <div className="talent-box">
                    <div className="talent-img">
                      <img
                        // ? process.env.REACT_APP_API_URL +
                        src={
                          e?.recent_freelancer?.profile_picture
                            ? e?.recent_freelancer?.profile_picture
                                ?.profile_picture
                            : TalentImg
                        }
                        alt="Talent"
                      />
                    </div>
                    <div className="talent-content">
                      <h4>{e?.recent_freelancer?.user?.name}</h4>
                      <h5>{e?.recent_freelancer?.user?.role}</h5>
                    </div>
                    {/* {e?.recent_freelancer?.ratings?.length === 0 &&
                      !isReview && (
                        <span
                          className="p-link"
                          onClick={() => setIsReview(true)}
                        >
                          Review Your Hire
                        </span>
                      )} */}
                    {e?.recent_freelancer?.ratings?.length === 0 &&
                      Array(5)
                        .fill()
                        .map((_, i) => (
                          <FaRegStar
                            key={i}
                            size={25}
                            className="mx-1"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              handleReview(e?.recent_freelancer?.id, i + 1)
                            }
                          />
                        ))}
                    {e?.recent_freelancer?.ratings.length !== 0 &&
                      Array(e?.recent_freelancer?.ratings[0].value)
                        .fill()
                        .map((_, i) => (
                          <FaStar key={i} size={25} className="mx-1" />
                        ))}
                  </div>
                </div>
              ))}
            </div>
            <div className="primary-heading color-dark mt-3">
              <p>
                You haven't save anyone yet. Start saving to help you remember
                that talent caught your eye.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
